import './styles.less';
import PropTypes from 'prop-types';
import React from 'react';

const TransportCustomModalCell = ({ rowData }) => {
	if (rowData.id === 'author') {
		return (
			<span className="custom-modal-cell__author">
				<b>{rowData.value.name}</b>
				<small>
					<i>{rowData.value.role}</i>
				</small>
			</span>
		);
	}

	if (rowData.id === 'tariffs') {
		return (
			<div className="transport-custom-modal-cell__tariffs">
				{rowData.value.map(tariff => {
					if (tariff.isHeader) {
						return (
							<div key={tariff.id} className="transport-custom-modal-cell__tariff-header">
								{tariff.title}
							</div>
						);
					}

					return (
						<div key={tariff.id} className="transport-custom-modal-cell__tariff-row">
							<span className="transport-custom-modal-cell__tariff-title">{tariff.title}</span>
							<span className="transport-custom-modal-cell__tariff-value">{tariff.value}</span>
						</div>
					);
				})}
			</div>
		);
	}

	if (typeof rowData.value === 'object') return '';

	return rowData.value || '-';
};

TransportCustomModalCell.propTypes = {
	rowData: PropTypes.object.isRequired,
	columnId: PropTypes.string.isRequired,
};

export { TransportCustomModalCell };
